import styled from "styled-components";
import { palette, size } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .no-wages-buttons {
    margin-top: 40px;
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .no-wages-buttons button {
    margin: 20px 15px;
  }
  
  &.is-submitting {
    &:not(.id-matrix) .id-matrix-button, &:not(.email-instead) .email-instead-button {
      opacity: 0;
      pointer-events: none;
    }
  }

  &:not(.is-submitting) button[disabled] {
    transition-delay: 2s;
    opacity: 0.2;
    pointer-events: none;
  }

  button {
    transition: opacity 200ms;
    
    :hover {
      background-color: ${palette("button.default", 2)};
      border-radius: ${size("borderRadius")};
    }
  }
  
  .page-heading {
    text-transform: none;
    padding-top: 8px;
  }
  
  a {
    white-space: nowrap;
    color: ${palette("color", 14)};
    text-decoration: none;
  }
  
  .tooltip-item-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
  }
`;